// extracted by mini-css-extract-plugin
module.exports = {"form":"d7f943","form__element":"_740095","form__recaptcha-text":"_3f8385","form__recaptcha-link":"_54956a"};